import {Head, Link} from '@inertiajs/react'

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Album from '../../components/album.jsx';

export default function EventAlbum({event, photos, aspectRatio, isDisposable, link, reloadUrl}) {
    return (
        <main>
            <Head title={event.name + ' - Public Album'}/>
            <div className="flex flex-col md:flex-row justify-between pt-6 mb-4 md:items-center backdrop-blur-3xl sticky top-0 z-40">
                <div className="px-[20px]">
                    <h1 className="text-white leading-tight text-xl md:text-3xl font-bold">Album</h1>
                    <span className="text-xs text-white leading-tight">{event.name}</span>
                </div>

                <div className="items-center flex justify-end mb-2">
                    <Link
                        href={link}
                        replace
                        preserveScroll
                        className="text-white block bg-gray-800 mr-[20px] rounded-full px-4 py-2 text-xs mdtext-sm font-semibold hover:bg-gray-600 transition duration-150 ease-in-out"
                    >{isDisposable ? 'Disable effect' : 'Enable effect'}</Link>
                </div>
            </div>
            <Album reloadUrl={reloadUrl} event={event} aspectRatio={aspectRatio} photos={photos} />
        </main>
    )
}
